<template>
  <div style="background: #FFFFFF">
    <div class="app-body-1160px">
      <!-- 标题 -->
      <ModuleHeader title="交流小组" detail="上万名志同道合的小伙伴在这里等你 (点击加入)"></ModuleHeader>
      <!-- 主体 -->
      <div id="app-discuss-group-body">
        <ul>
          <li style="float: left" v-for="item in groupInfo" :key="item.id">
            <a :href="item.gid" target="_blank">
              <el-card class="app-discuss-group-card">
                <img class="app-discuss-group-card-img" alt="pic" src="https://img.blendermagic.cn/new/icon/group.png"/>
                <div class="app-discuss-group-card-content">blender魔法CG交流群 {{ item.indexId }}群</div>
              </el-card>
            </a>
          </li>
        </ul>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>

import ModuleHeader from "@/views/share/home/ModuleHeader";

export default {
  name: "DiscussGroup",
  components: {
    ModuleHeader
  },
  data() {
    return {
      groupInfo: [
        {
          indexId: 1,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=0s16nZurQS8XRTrbkxPrfj-XeslDjkmP&jump_from=webapi'
        },
        {
          indexId: 2,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=TfPXjSDN4gUPrHNvVs7BokaGrQI7SBTQ&jump_from=webapi'
        },
        {
          indexId: 3,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=lJQv9siwD5EGk92EL7_idlkjafTS_NXw&jump_from=webapi'
        },
        {
          indexId: 4,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=LdNbpypmJ1np6NmX4jy4emOSvi5CksK2&jump_from=webapi'
        },
        {
          indexId: 5,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=460SkpavAE8Jh5_xQqRBbj0o-9S-Y1n4&jump_from=webapi'
        },
        {
          indexId: 6,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=9fhxCYtvIanE-3D4W3m255nvZIpOhlPL&jump_from=webapi'
        },
        {
          indexId: 7,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=qJjceYjY422RpoKKtxKaA9JxOMYivt6c&jump_from=webapi'
        },
        {
          indexId: 8,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=BT2XpkX0eZqfeRGAi-HYhdW6pvTMzzd3&jump_from=webapi'
        },
        {
          indexId: 9,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=Xjdsk0hQCexxBJF03-W479a27iHgpv2h&jump_from=webapi'
        },
        {
          indexId: 10,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=K3wVvLcIBh2LsTbljL5eaQlVmFKj34c-&jump_from=webapi'
        },
        {
          indexId: 11,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=3qOOsz7dUg4_AjtydLU6EC2JBWXLlAQT&jump_from=webapi'
        },
        {
          indexId: 12,
          gid: 'https://qm.qq.com/cgi-bin/qm/qr?k=Q6y5MRte3FDx4h6xnKGg12Y21ERWddwo&jump_from=webapi'
        },
      ]
    }
  }
}
</script>

<style scoped>

#app-discuss-group-body {
  position: relative;
  padding-bottom: 25px;
}

.app-discuss-group-card {
  position: relative;
  width: 310px;
  height: 100px;
  margin-left: 55px;
  margin-bottom: 25px;
  cursor: pointer;
  line-height: 100px;
  text-align: left;
}

.app-discuss-group-card:hover {
  transition: all 500ms ease-out;
  transform: scale(1.05);
}

.app-discuss-group-card-img {
  position: relative;
  top: 18px;
  left: 18px;
  border-radius: 32px;
  width: 64px;
  height: 64px;
}

.app-discuss-group-card-content {
  position: absolute;
  left: 100px;
  right: 0;
  top: 0;
  bottom: 0;
  line-height: 100px;
}


</style>